import { render, staticRenderFns } from "./StudentGraduations.vue?vue&type=template&id=1247efc4"
import script from "./StudentGraduations.vue?vue&type=script&lang=js"
export * from "./StudentGraduations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports